var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !!(_vm.report && _vm.report.config && _vm.report.config.dataSource)
    ? _c(
        "section",
        { staticClass: "lexon-view-container" },
        [
          _c("AlertComponent", {
            attrs: {
              whereIsRendered: _vm.componentWhereIsRenderedAlertComponent,
            },
          }),
          _c("ReportFilterComponent", {
            attrs: {
              filters: _vm.filters,
              title: _vm.reportName,
              breadcrumbs: _vm.breadcrumbItems,
              goBackRouteName: _vm.goBackRouteName,
            },
            on: {
              filter: _vm.reloadPivotTable,
              "clear-table": _vm.onClearTable,
            },
          }),
          _c("GridPivotTableComponent", {
            key: _vm.pivotKey,
            attrs: {
              title: _vm.$t("views.reports.title"),
              dataSourceSettings: _vm.report,
              fetchSettings: _vm.fetchReportDataAction,
              saveSettings: _vm.postReportsAction,
              disableToolbarÏtems: _vm.disableToolbarÏtems,
            },
            on: { "reload-pivot-table": _vm.reloadPivotTable },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }